import { useMutation } from "@tanstack/react-query";

import { verifyMfaRequest } from "../requests/verify-mfa-request";

export const useVerifyMfaMutation = () => {
  return useMutation({
    mutationFn: verifyMfaRequest,
  });
};
